import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import { User } from '../../types/backend-dto-types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

export interface UserWithActivity extends User {
  kimActive: boolean;
  runActive: boolean;
  fairUsageCreditLimit: number | null;
}

export const useFetchOrgUsers = (orgId: string = '', enabled: boolean = true) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UserWithActivity[]>(
    [QueryEntity.Users, { orgId }],
    async () => {
      const params = new URLSearchParams({ orgId });
      const queryParams = params.toString();

      try {
        const res = await fetch(`${APIBaseChronos}/api/org/users?${queryParams}`, fetchConfigGET);
        if (!res.ok) {
          throw new Error('Failed to fetch users');
        }
        return await res.json();
      } catch (err) {
        throw err;
      }
    },
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );
};
